import {Component, computed, inject, input} from '@angular/core';
import {Dropdown, DropdownItem} from '../dropdown/dropdown';
import {NgOptimizedImage} from '@angular/common';
import {FormControl} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'elcia-country-dropdown',
  imports: [
    Dropdown,
    NgOptimizedImage,
    TranslatePipe
  ],
  templateUrl: './country-dropdown.html',
  styleUrl: './country-dropdown.scss',
})
export class CountryDropdown {
  private readonly translateService = inject(TranslateService);
  private readonly langChange = toSignal(this.translateService.onLangChange, {initialValue: null});

  control = input.required<FormControl<string | null>>();

  private readonly countryCodes = ['FR', 'BE', 'CH', 'DE', 'EN', 'ES', 'IT', 'LU', 'NL', 'PL', 'PT'];

  // Names must be translated here (not in the template): the dropdown filter searches on the item name
  protected readonly items = computed<DropdownItem[]>(() => {
    this.langChange();
    return this.countryCodes.map((code) => ({
      id: code,
      name: this.translateService.instant(`country.${code}`),
      imageUrl: `images/countries/${code.toLowerCase()}.png`,
    }));
  });
}
